import { css } from 'aphrodite';
import React from 'react';
import { getFileSizeStringValue } from '../../../models/UiUtils';
import { Button } from '../../components-v2/Button';
import { THEME } from '../../components-v2/Theme/theme';
import { baseStyleSheet } from '../../styles/styles';
import { SparklesIcon } from '../svgs/icons/SparklesIcon';
import { XIcon } from '../svgs/icons/XIcon';
import { styleSheet } from './styles';

interface ImagePreviewProps {
	url: string;
	fileName: string;
	source?: 'Upload' | 'Pixabay';
	fileSize: number; // Assuming the size is in bytes
	onRemove: () => void; // Callback function to handle the removal of the image
	onEdit?: () => void; // Optional callback for AI image editing
	editButtonLabel?: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
	url,
	fileName,
	fileSize,
	source,
	onRemove,
	onEdit,
	editButtonLabel = 'Edit Image with AI',
}) => {
	// Convert file size from bytes to a more readable format (KB/MB)
	const readableFileSize = getFileSizeStringValue(fileSize);

	return (
		<div className={css(styleSheet.imageContainer)}>
			<figure className={css(styleSheet.imageWrap)}>
				<img src={url} alt='Preview' className={css(styleSheet.image)} />
			</figure>
			<section className={css(styleSheet.imageSection)}>
				<div className={css(styleSheet.closeButtonContainer)}>
					<button onClick={onRemove}>
						<XIcon height={14} width={14} color={THEME.colors.icon.gray} />
					</button>
				</div>
				<h3>File Name: {fileName}</h3>
				<p className={css(baseStyleSheet.m0)}>File Size: {readableFileSize}</p>
				{source ? <p className={css(baseStyleSheet.m0)}>Source: {source}</p> : null}
				{onEdit && (
					<div className={css(styleSheet.imageActions)}>
						<Button size='sm' variant='secondary' onClick={onEdit}>
							<SparklesIcon />
							{editButtonLabel}
						</Button>
					</div>
				)}
			</section>
		</div>
	);
};
